export default defineNuxtRouteMiddleware((to) => {
  const oldContextRootRegExp = /^\/app(\/|$)/

  if (oldContextRootRegExp.test(to.fullPath)) {
    return navigateTo({ name: 'dashboard' })
  }

  return null
})
